import { gql, TypedDocumentNode } from "@apollo/client";

import { PageInfo, QuerySearchRepoCommitsArgs, RepoCommit } from "types/generated";

export type SearchSpaceliftVcsRepoCommitsItem = Pick<
  RepoCommit,
  "id" | "sha" | "message" | "description" | "authorName" | "authorEmail" | "createdAt"
>;

type SearchSpaceliftVcsRepoCommitsData = {
  searchRepoCommits: {
    edges: Array<{ cursor: string; node: SearchSpaceliftVcsRepoCommitsItem }>;
    pageInfo: Pick<PageInfo, "hasNextPage" | "endCursor">;
  };
};

export const SEARCH_SPACELIFT_VCS_REPO_COMMITS: TypedDocumentNode<
  SearchSpaceliftVcsRepoCommitsData,
  QuerySearchRepoCommitsArgs
> = gql`
  query SearchSpaceliftVcsRepoCommits($repoID: ID!, $input: SearchInput!) {
    searchRepoCommits(repoID: $repoID, input: $input) {
      edges {
        cursor
        node {
          id
          sha
          message
          description
          authorName
          authorEmail
          createdAt
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
